<inbox-views *ngIf="showInboxViews$ | async"></inbox-views>

<div class="toolbar" [formGroup]="formGroup" *ngIf="showToolbar$ | async">
  <glxy-form-field class="search-bar" suffixIcon="search" bottomSpacing="none" size="medium" *ngIf="showSearchBar">
    <input
      matInput
      formControlName="search"
      type="search"
      autocomplete="off"
      [placeholder]="'INBOX.NEW_MESSAGE.NAME_OR_PHONE' | translate"
    />
  </glxy-form-field>

  <glxy-form-field
    class="views"
    bottomSpacing="none"
    size="medium"
    *ngIf="showFilters$ | async"
    [class.small-views]="showSearchBar"
  >
    <mat-select formControlName="view" class="filters" [panelWidth]="null">
      <mat-select-trigger>
        @if (formGroup.controls.view.value; as view) {
          {{ inboxViewsTranslations[view] | translate }}
        }
      </mat-select-trigger>
      <mat-option value="none">{{ inboxViewsTranslations['none'] | translate }}</mat-option>
      <mat-option value="closed">{{ inboxViewsTranslations['closed'] | translate }}</mat-option>
      <mat-divider></mat-divider>
      <mat-option value="anonymous">{{ inboxViewsTranslations['anonymous'] | translate }}</mat-option>
    </mat-select>
  </glxy-form-field>
</div>

<!-- Conversations section -->
<div class="conversation-list" *ngIf="(emptyConversations$ | async) !== true">
  <div
    *ngFor="let conversationDetail of filteredConversations$ | async; trackBy: trackConversationDetailsById"
    class="conversation"
  >
    <a
      *ngIf="conversationDetail"
      [routerLink]="conversationDetail | conversationRoute: conversationPath"
      [queryParams]="{ inboxPrefilledMessage: null }"
      queryParamsHandling="merge"
      routerLinkActive="active-conversation"
      (click)="conversationSelected(true)"
      data-action="clicked-conversation"
    >
      <ng-container *ngIf="(conversationDetail | conversationYourExpert) || !isBusinessApp; else businessApp">
        <div [class.unread-font-weight]="conversationDetail.conversation | conversationUnseen | async">
          <div class="header-container row">
            <div *ngIf="displayBadge$ | async" class="badges-group">
              <div *ngFor="let badge of conversationDetail | conversationBadge" class="badge">
                <glxy-badge [color]="badge.badgeColor" [size]="'small'">
                  {{ badge.participantType | translate }}
                </glxy-badge>
              </div>
            </div>
            <div *ngIf="conversationDetail | conversationYourExpert">
              <glxy-badge [color]="'green'" [size]="'small'">
                {{ 'INBOX.YOUR_EXPERT' | translate }}
              </glxy-badge>
            </div>
            <div class="side-info-container row">
              <div
                class="timestamp {{
                  (conversationDetail.conversation | conversationUnseen | async) === true
                    ? 'unread-color'
                    : 'read-color'
                }}"
              >
                {{ conversationDetail | timestamp }}
              </div>
              <div
                class="dot-container"
                [ngClass]="{ 'unread-display': (conversationDetail.conversation | conversationUnseen | async) }"
              >
                <div class="dot"></div>
              </div>
            </div>
          </div>
          <div>
            <inbox-conversation-title [conversationDetail]="conversationDetail"></inbox-conversation-title>
            <inbox-conversation-preview [conversationDetail]="conversationDetail"></inbox-conversation-preview>
          </div>
        </div>
      </ng-container>
      <ng-template #businessApp>
        <div [ngClass]="{ 'unread-font-weight': (conversationDetail.conversation | conversationUnseen | async) }">
          <div class="business-app-header row">
            <inbox-conversation-title [conversationDetail]="conversationDetail"></inbox-conversation-title>
            <div class="side-info-container row">
              <div
                class="timestamp {{
                  (conversationDetail.conversation | conversationUnseen | async) === true
                    ? 'unread-color'
                    : 'read-color'
                }}"
              >
                {{ conversationDetail | timestamp }}
              </div>
              <div
                class="dot-container"
                [ngClass]="{ 'unread-display': (conversationDetail.conversation | conversationUnseen | async) }"
              >
                <div class="dot"></div>
              </div>
            </div>
          </div>
          <inbox-conversation-preview [conversationDetail]="conversationDetail"></inbox-conversation-preview>
        </div>
      </ng-template>
    </a>
  </div>
  <glxy-infinite-scroll-trigger (isVisible)="loadMoreConversations()" />
  <glxy-loading-spinner *ngIf="(loadingConversations$ | async) === true" />
</div>

<inbox-views-empty *ngIf="showEmptyView$ | async"></inbox-views-empty>

<inbox-zero *ngIf="showInboxZero$ | async" [showNewMessageButton]="canAccessSMS$ | async"></inbox-zero>
